define([
	"dojo/_base/declare",
	"csi/locale",
	"csi/state",
	"csi/table/Widget",
	"./util"
], function(declare,locale,state,Widget,util) {

	return declare(Widget, {
		/**
		 * Add warning message indicating this is a shared section and edits will apply to all
		 */
		postCreate: function() {
			this.inherited(arguments);

			if (!state.get("print")) {
				this.invalidNode.set("icon", this.invalidNode.WARNING);
				this.invalidNode.set("value", locale.resource("SharedSectionWarning"));
			}
		},

		/**
		 * Return true if edited attribute is in mapping for subtype, as the ResetMappedAttributes action may need to be redrawn
		 */
		hasRefNodeDependency: function(node, heading, typeAttr) {
			return util.isAttributeInSectionItemAttributeMap(heading.m_id, node, this.cacheView) || this.inherited(arguments);
		},

		/**
		 * Return true if item attributes have been changed after mapping from library
		 * @param {Context} ctx
		 * @param {Action} action
		 * @return {boolean}
		 */
		isItemChangedFromMapping: function(ctx, action) {
			return util.isSectionItemChangedFromMapping(ctx);
		},

		/**
		 * Indicate that we want to render disabled row actions
		 */
		onCreateMainQueryLevel: function(ql) {
			ql.bRenderDisabledActions = true;
		}
	});
});
